import React, { useRef, useState, useEffect } from "react";
import styles from "./Time.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const DatePicker = ({setDate}) => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedDay, setSelectedDay] = useState(new Date().getDate());
  const [selectedInput, setSelectedInput] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const yearRef = useRef(null);
  const monthRef = useRef(null);
  const dayRef = useRef(null);

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i);

  const allMonths = [
    { number: 1, name: t('monthNames.january') },
    { number: 2, name: t('monthNames.february') },
    { number: 3, name: t('monthNames.march') },
    { number: 4, name: t('monthNames.april') },
    { number: 5, name: t('monthNames.may') },
    { number: 6, name: t('monthNames.june') },
    { number: 7, name: t('monthNames.july') },
    { number: 8, name: t('monthNames.august') },
    { number: 9, name: t('monthNames.september') },
    { number: 10, name: t('monthNames.october') },
    { number: 11, name: t('monthNames.november') },
    { number: 12, name: t('monthNames.december') },
  ];

  const scroll = (ref, direction) => {
    let scrollInterval = setInterval(() => {
      ref.current.scrollLeft += direction * 10;
    }, 10);

    const stopScroll = () => {
      clearInterval(scrollInterval);
      window.removeEventListener("mouseup", stopScroll);
      window.removeEventListener("touchend", stopScroll);
    };

    window.addEventListener("mouseup", stopScroll);
    window.addEventListener("touchend", stopScroll);
  };

  const currentMonthIndex = new Date().getMonth();
  const months = allMonths.slice(currentMonthIndex).concat(allMonths.slice(0, currentMonthIndex));

  const generateDays = (year, month) => {
    const totalDays = new Date(year, month, 0).getDate();
    const today = new Date().getDate();
    const daysArray = Array.from({ length: totalDays }, (_, i) => i + 1);

    return daysArray.slice(today - 1).concat(daysArray.slice(0, today - 1));
  };

  const [days, setDays] = useState(generateDays(selectedYear, selectedMonth));

  useEffect(() => {
    setDays(generateDays(selectedYear, selectedMonth));
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    const formattedDate = `${selectedYear}-${String(selectedMonth).padStart(2, "0")}-${String(selectedDay).padStart(2, "0")}`;
    console.log("date", formattedDate);
    setDate(formattedDate)
  }, [selectedYear, selectedMonth, selectedDay]);

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      {/* Year Selector */}
      <div className={styles.years}>
        <div className={styles.label} style={{ borderRadius: currentLanguage === 'ar' ? '0 8px 8px 0' : '8px 0 0 8px' }}>
          {t('year')}
        </div>
        <button className={styles.arrowButton} onMouseDown={() => scroll(yearRef, 1)}>
          {"<"}
        </button>
        <div className={styles.scrollContainer} ref={yearRef}>
          {years.map((year) => (
            <button
              key={year}
              className={`${styles.button} ${year === selectedYear ? styles.selected : ""}`}
              onClick={() => setSelectedYear(year)}
            >
              {year}
            </button>
          ))}
        </div>
        <button className={styles.arrowButton} onMouseDown={() => scroll(yearRef, -1)}>
          {">"}
        </button>
      </div>

      {/* Month Selector */}
      <div className={styles.years} style={{ marginTop: "10px" }}>
        <div className={styles.label} style={{ borderRadius: currentLanguage === 'ar' ? '0 8px 8px 0' : '8px 0 0 8px' }}>
          {t("month")}
        </div>
        <button className={styles.arrowButton} onMouseDown={() => scroll(monthRef, 1)}>
          {"<"}
        </button>
        <div className={styles.scrollContainer} ref={monthRef}>
          {months.map((month) => (
            <button
              key={month?.number}
              className={`${styles.button} ${month.number === selectedMonth ? styles.selected : ""}`}
              onClick={() => setSelectedMonth(month.number)}
            >
              {month.name}
            </button>
          ))}
        </div>
        <button className={styles.arrowButton} onMouseDown={() => scroll(monthRef, -1)}>
          {">"}
        </button>
      </div>

      {/* Day Selector */}
      <div className={styles.years} style={{ marginTop: "10px" }}>
        <div className={styles.label} style={{ borderRadius: currentLanguage === 'ar' ? '0 8px 8px 0' : '8px 0 0 8px' }}>
          {t('day')}
        </div>
        <button className={styles.arrowButton} onMouseDown={() => scroll(dayRef, 1)}>
          {"<"}
        </button>
        <div className={styles.scrollContainerDays} ref={dayRef}>
          {days.map((day) => (
            <button
              key={day}
              className={`${styles.buttonDays} ${day === selectedDay ? styles.selected : ""}`}
              onClick={() => setSelectedDay(day)}
            >
              {day}
            </button>
          ))}
        </div>
        <button className={styles.arrowButton} onMouseDown={() => scroll(dayRef, -1)}>
          {">"}
        </button>
      </div>
    </div>
  );
};

export default DatePicker;
